import { useState, useEffect } from 'react'

export function useIsTouchDevice(): boolean {
  const [isTouchDevice, setIsTouchDevice] = useState(false)

  useEffect(() => {
    const onTouch =
      typeof window !== 'undefined' && ('ontouchstart' in window || navigator.maxTouchPoints > 0)

    setIsTouchDevice(onTouch)
  }, [])

  return isTouchDevice
}
